// Continents dérivés du code pays ISO 3166-1 alpha-2 (client-safe).
export const CONTINENTS = [
  "Europe",
  "Afrique",
  "Asie",
  "Amérique du Nord",
  "Amérique du Sud",
  "Océanie",
] as const;
export type Continent = (typeof CONTINENTS)[number];

const EUROPE = "AL AD AT BY BE BA BG HR CY CZ DK EE FI FR DE GI GR HU IS IE IM IT XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RS SK SI ES SE CH UA GB VA TR RU";
const AFRICA = "DZ AO BJ BW BF BI CM CV CF TD KM CD CG CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU MA MZ NA NE NG RW ST SN SC SL SO ZA SS SD TZ TG TN UG ZM ZW";
const ASIA = "AF AM AZ BH BD BT BN KH CN GE HK IN ID IR IQ IL JP JO KZ KW KG LA LB MY MV MN MM NP KP OM PK PS PH QA SA SG KR LK SY TW TJ TH TL UZ VN YE AE";
const NORTH_AMERICA = "AG BS BB BZ BM CA CR CU DM DO SV GL GD GT HT HN JM MX NI PA PR KN LC VC TT US VG";
const SOUTH_AMERICA = "AR BO BR CL CO EC FK GF GY PY PE SR UY VE";
const OCEANIA = "AS AU CK FJ PF GU KI MH FM NR NC NZ NU MP PW PG PN WS SB TK TO TV VU WF";

const MAP: Record<string, Continent> = {};
const fill = (codes: string, name: Continent) => {
  for (const c of codes.split(" ")) MAP[c] = name;
};
fill(EUROPE, "Europe");
fill(AFRICA, "Afrique");
fill(ASIA, "Asie");
fill(NORTH_AMERICA, "Amérique du Nord");
fill(SOUTH_AMERICA, "Amérique du Sud");
fill(OCEANIA, "Océanie");

/** Continent d'un code pays ISO 2 lettres (« Autre » si inconnu). */
export function continentOf(code: string | null | undefined): string {
  return MAP[(code || "").toUpperCase()] ?? "Autre";
}

/** Continents distincts d'une liste de villes (colonne `continent` prioritaire). */
export function distinctContinents(
  rows: { continent?: string | null; country_code?: string | null }[],
): string[] {
  const set = new Set<string>();
  for (const r of rows) {
    const value = (r.continent || "").trim() || continentOf(r.country_code);
    if (value && value !== "Autre") set.add(value);
  }
  return [...set];
}
